module.exports = "/assets/packs/images/fc8c841116f65dd35f9df58d1ac4bf00.png";